import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { CurrentMatchedPaperState } from '../types';

/**
 * 当前匹配论文排行榜模型
 * @description 存储当前匹配论文排行榜状态
 */
export interface CurrentMatchedPaperModel extends Model<CurrentMatchedPaperState>, Disposable {

}

export const CurrentMatchedPaperModel = Symbol.for('CurrentMatchedPaperModel');
